import { ApolloProvider } from '@apollo/client';
import { DataFetchingClientProvider } from 'data-fetching-client';
import { createApolloClient } from 'hubspot-apollo-client';
import { createContext, useContext, useMemo } from 'react';
import { ViewsActionsProvider } from '../viewsActions/context/ViewsActionsModalContext';
import { getDefaultDataFetchingClient } from './getDefaultDataFetchingClient';
import { jsx as _jsx } from "react/jsx-runtime";
const ClientsContext = /*#__PURE__*/createContext(null);

/**
 * Provides DataFetchingClient and ApolloClient Contexts
 * The default DataFetchingClient is generated with view-specfic queryFieldPolicies
 *
 * If rendered inside of another ViewsManagementProvider, the clients provided
 * by the outer context will be used
 *
 * This means that nesting two ViewsManagementProviders will result in a shared cache
 * (assuming prop overrides aren't used)
 *
 * Apps can also provide their own DataFetchingClient and ApolloClient instances
 * if they have merged the query and mutation typePolicies in manually
 */
export const ViewsManagementProvider = ({
  children,
  dfcClient,
  apolloClient
}) => {
  const {
    client: dfcClientFromContext,
    apolloClient: apolloClientFromContext
  } = useContext(ClientsContext) || {};
  const resolvedClient = useMemo(() => dfcClient || dfcClientFromContext || getDefaultDataFetchingClient(), [dfcClient, dfcClientFromContext]);
  const resolvedApolloClient = useMemo(() => apolloClient || apolloClientFromContext || createApolloClient(), [apolloClient, apolloClientFromContext]);
  return /*#__PURE__*/_jsx(ClientsContext.Provider, {
    value: {
      client: resolvedClient,
      apolloClient: resolvedApolloClient
    },
    children: /*#__PURE__*/_jsx(ApolloProvider, {
      client: resolvedApolloClient,
      children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
        client: resolvedClient,
        children: /*#__PURE__*/_jsx(ViewsActionsProvider, {
          children: children
        })
      })
    })
  });
};